function FilterMixitMobile() {
    $('.js-filter-mixit-nav').on("click", function () {
        let $this = $(this);
        $this.toggleClass('is-active');
        $('.js-filter-mixit-menu').slideToggle();
    });
}

export { FilterMixitMobile };